import { useContext, useEffect, useState } from 'react';

import Logo from 'components/logo';
import RegulamentoLayout from 'components/regulamento-layout';
import { RegulamentoContent } from 'components/regulamento-content';
import { AuthContext } from 'context/AuthContext';
import { getRegulation, IRegulation } from 'services/regulation.service';

// "Baixar PDF" imprime a própria página: o navegador oferece "Salvar como PDF" (AJ2-52).
function imprimirRegulamento() {
  window.print();
}

export default function Regulamento() {
  const [regulation, setRegulation] = useState<IRegulation>();
  const { user, cycleSelected } = useContext(AuthContext);

  useEffect(() => {
    async function loadData() {
      const data = await getRegulation(user?.extra.rede);
      if (data) {
        setRegulation(data);
      }
    }

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegulamentoLayout title="Regras">
      {/* `.jj-regras` escopa o `@media print` desta página (AJ2-56): fora dela, a impressão segue igual. */}
      <div className="jj-regras">
        {/* Cabeçalho só da impressão: logo e título com o ciclo (AJ2-54). */}
        <div className="jj-regras__cabecalho-impresso">
          <div className="w-40">
            <Logo />
          </div>
          <p className="m-0 font-display text-[22px] font-extrabold text-brand-blue-dark">
            Regras do #JogaJuntoBB{cycleSelected?.title ? ` ${cycleSelected.title}` : ''}
          </p>
        </div>

        <div className="jj-regras__faixa mb-3.5 flex flex-wrap items-center gap-5 rounded-2xl bg-brand-blue px-7 py-[22px] text-brand-white">
          <div className="min-w-[280px] flex-1">
            <p className="m-0 font-display text-[19px] font-bold text-brand-yellow">Regras do #JogaJuntoBB</p>
            <p className="m-0 mt-[7px] text-[13px] leading-[1.55] opacity-90">
              Regulamento vigente do Programa, com conceito, dinâmicas, pontuação e premiação.
            </p>
          </div>

          {!!cycleSelected?.title && (
            <span className="rounded-full bg-white/[0.14] px-4 py-2 font-display text-xs font-bold text-brand-yellow">
              #JOGAJUNTOBB {cycleSelected.title}
            </span>
          )}

          <button
            type="button"
            onClick={imprimirRegulamento}
            className="rounded-md bg-brand-yellow px-4 py-2 font-display text-xs font-bold uppercase tracking-wide text-brand-blue-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-white"
          >
            Baixar PDF
          </button>

          {/* O arquivo publicado no CMS continua acessível como a versão oficial (AJ2-53). */}
          {!!regulation?.regulation?.url && (
            <a
              href={regulation.regulation.url}
              target="_blank"
              rel="noreferrer"
              className="font-display text-xs font-bold text-brand-white underline underline-offset-2 hover:text-brand-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-white"
            >
              Versão oficial (PDF)
            </a>
          )}
        </div>

        <div className="jj-prose rounded-2xl bg-brand-white px-8 pb-8 pt-6 shadow-[0_1px_2px_rgba(21,21,24,.08),0_1px_3px_rgba(25,25,28,.12)]">
          <RegulamentoContent rede={user?.extra.rede} semSumario />
        </div>
      </div>
    </RegulamentoLayout>
  );
}
